function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg204Micronesia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#338AF3"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "255.999,128 265.775,158.087 297.412,158.087 271.817,176.682 281.593,206.769    255.999,188.176 230.406,206.769 240.183,176.682 214.588,158.087 246.224,158.087  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "128,256.002 158.087,246.225 158.087,214.588 176.682,240.183 206.769,230.407    188.174,256.002 206.769,281.594 176.682,271.817 158.087,297.412 158.087,265.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "256.001,384 246.225,353.913 214.588,353.913 240.183,335.318 230.407,305.231    256.001,323.824 281.594,305.231 271.817,335.318 297.412,353.913 265.776,353.913  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "384,255.999 353.913,265.775 353.913,297.412 335.318,271.817 305.231,281.593    323.824,255.999 305.231,230.406 335.318,240.183 353.913,214.588 353.913,246.224  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg204Micronesia);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgc3R5bGU9ImZpbGw6IzMzOEFGMzsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIi8+CjxnPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHBvaW50cz0iMjU1Ljk5OSwxMjggMjY1Ljc3NSwxNTguMDg3IDI5Ny40MTIsMTU4LjA4NyAyNzEuODE3LDE3Ni42ODIgMjgxLjU5MywyMDYuNzY5ICAgIDI1NS45OTksMTg4LjE3NiAyMzAuNDA2LDIwNi43NjkgMjQwLjE4MywxNzYuNjgyIDIxNC41ODgsMTU4LjA4NyAyNDYuMjI0LDE1OC4wODcgICIvPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHBvaW50cz0iMTI4LDI1Ni4wMDIgMTU4LjA4NywyNDYuMjI1IDE1OC4wODcsMjE0LjU4OCAxNzYuNjgyLDI0MC4xODMgMjA2Ljc2OSwyMzAuNDA3ICAgIDE4OC4xNzQsMjU2LjAwMiAyMDYuNzY5LDI4MS41OTQgMTc2LjY4MiwyNzEuODE3IDE1OC4wODcsMjk3LjQxMiAxNTguMDg3LDI2NS43NzYgICIvPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHBvaW50cz0iMjU2LjAwMSwzODQgMjQ2LjIyNSwzNTMuOTEzIDIxNC41ODgsMzUzLjkxMyAyNDAuMTgzLDMzNS4zMTggMjMwLjQwNywzMDUuMjMxICAgIDI1Ni4wMDEsMzIzLjgyNCAyODEuNTk0LDMwNS4yMzEgMjcxLjgxNywzMzUuMzE4IDI5Ny40MTIsMzUzLjkxMyAyNjUuNzc2LDM1My45MTMgICIvPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHBvaW50cz0iMzg0LDI1NS45OTkgMzUzLjkxMywyNjUuNzc1IDM1My45MTMsMjk3LjQxMiAzMzUuMzE4LDI3MS44MTcgMzA1LjIzMSwyODEuNTkzICAgIDMyMy44MjQsMjU1Ljk5OSAzMDUuMjMxLDIzMC40MDYgMzM1LjMxOCwyNDAuMTgzIDM1My45MTMsMjE0LjU4OCAzNTMuOTEzLDI0Ni4yMjQgICIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };